import { GetClientsRequest } from "@/Stub/V1";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { QueryKeys } from "@/Service/Api/V1/QueryKeys/QueryKeys";
import { ClientsApiClient } from "@/Service/Api/V1/ApiClients/ClientsApiClient";

export type useGetClientsParams = {
    requestParams?: GetClientsRequest
    enabled?: boolean
    savePreviousData?: boolean
};

export const useGetClients = ({ requestParams, enabled, savePreviousData }: useGetClientsParams = {}) => useQuery({
    ...QueryKeys.clients.list(requestParams),
    queryFn: async () => await ClientsApiClient.getClients(requestParams),
    enabled,
    gcTime: 0,
    placeholderData: savePreviousData ? keepPreviousData : undefined
});